module.exports = {
    ...require('./ethers.constant'),
    ...require('./abi.constant')
}
